/**
 * Utility to mask customer phone numbers showing only the last 4 digits.
 * Example inputs:
 *  "9876543210" -> "******3210"
 *  "+919876543210" -> "******3210"
 *  "123" -> "123"
 */
export function maskPhoneNumber(phone?: string | null): string {
  if (!phone || typeof phone !== 'string') return '-'

  const trimmed = phone.trim()
  if (!trimmed) return '-'

  const digitsOnly = trimmed.replace(/\D/g, '')

  if (digitsOnly.length <= 4) return trimmed

  const last4 = digitsOnly.slice(-4)
  const prefixLength = digitsOnly.length - 4
  const maskStars = '*'.repeat(Math.max(6, prefixLength))

  return `${maskStars}${last4}`
}
